import { v4 as uuidv4 } from 'uuid';

export function Breadcrumb(props = {}, childrenComponents = []) {
	return {
		componentName: 'Breadcrumb',
		componentId: uuidv4(),
		props: Object.assign(
			{
				showOnMobile: true,
				homeIconSize: 26,
				caretIconSize: 8,
			},
			props,
		),
		childrenComponents,
	};
}
